import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ o("path", { d: "m22.303 21.564-7.724-7.723A7.71 7.71 0 0 0 16.5 8.75C16.5 4.477 13.023 1 8.75 1S1 4.477 1 8.75s3.477 7.75 7.75 7.75a7.702 7.702 0 0 0 4.737-1.63l7.755 7.755a.747.747 0 0 0 1.06 0 .75.75 0 0 0 0-1.06ZM2.5 8.75A6.257 6.257 0 0 1 8.75 2.5 6.257 6.257 0 0 1 15 8.75 6.257 6.257 0 0 1 8.75 15 6.257 6.257 0 0 1 2.5 8.75Z" }, null, -1), r = [
  c
];
function s(a, l) {
  return e(), t("svg", n, [...r]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
